import React from 'react';
import PropTypes from 'prop-types';
import {
  StyledName,
  StyledBoxName,
  StyledProfession,
  StyledCompany
} from './style';

const BoxName = ({
  className,
  employee,
  user,
  children,
  profession,
  company,
  altImage,
  onClick,
  userProfileView
}) => (
  <StyledBoxName className={className} employee={employee}>
    <StyledName onClick={onClick} userProfileView={userProfileView}>
      {' '}
      {user}{' '}
    </StyledName>
    {children}
    {employee && (
      <div>
        <StyledProfession>{profession}</StyledProfession>
        <StyledCompany alt={altImage} src={company} />
      </div>
    )}
  </StyledBoxName>
);

BoxName.propTypes = {
  className: PropTypes.string,
  employee: PropTypes.bool,
  user: PropTypes.string,
  children: PropTypes.node,
  profession: PropTypes.string,
  company: PropTypes.string,
  altImage: PropTypes.string,
  onClick: PropTypes.func,
  userProfileView: PropTypes.bool
};

BoxName.defaultProps = {};

export default BoxName;
